<template>
  <div v-if="error">
    <pre class="p-5 mt-4 mb-10 font-sans border rounded-md bg-red-100 text-red-700 text-sm dark:bg-red-800 dark:border-red-900 dark:text-white"><i class="fa fa-xmark-circle mr-4"></i>{{ error.message }}</pre>
  </div>
</template>